import getAuthClient from '../connectors/authClient';

const initialState = () => ({
  user: null,
  signInDomain: localStorage.getItem('signInDomain'),
});

const getters = {
  user: (state) => state.user,
  signInDomain: (state) => state.signInDomain,
};

const actions = {
  async login({ state, commit, dispatch }, { idToken, refreshToken, accessToken } = {}) {
    if (state.user || !state.signInDomain) {
      return;
    }
    const authClient = getAuthClient(state.signInDomain);
    const authSession = await authClient.initiateAuthenticatedAccess(
      idToken,
      refreshToken,
      process.env.VUE_APP_APP_ID,
      accessToken,
    );
    const user = await authSession.getUserData();
    user.session = {
      request: (...args) =>
        authSession.request(...args).then((response) => {
          if (response.status === 401) {
            dispatch('logout');
            window.location.reload();
          }
          if (!response.status?.toString().startsWith('2')) {
            throw new Error(response.data.error);
          }
          return response;
        }),
      signout: (...args) => authSession.signout(...args),
    };
    commit('setUser', user);
  },
  async logout({ state, commit }) {
    if (!state.user) {
      return;
    }
    await state.user.session.signout(process.env.VUE_APP_APP_ID);
    commit('removeSignInDomain');
    commit('setUser', null);
    localStorage.removeItem('previewerOperations');
  },
};

const mutations = {
  setUser(state, user) {
    Object.assign(state, {
      user,
    });
  },
  setSignInDomain(state, signInDomain) {
    Object.assign(state, {
      signInDomain,
    });
    localStorage.setItem('signInDomain', signInDomain);
  },
  removeSignInDomain(state) {
    localStorage.removeItem('signInDomain');
    Object.assign(state, {
      signInDomain: null,
    });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
